/* eslint-disable jsx-a11y/anchor-is-valid */

import { infoTooltipOpenAtom, showAvailableState } from '../states/planner';
import { useAtom } from 'jotai';

const AreaViewInfo = ({
  id,
  d,
  title,
  text,
  toolTipPlace,
  toolTipId,
}: {
  id: string;
  d: string;
  title: string;
  text: string;
  toolTipPlace: string;
  toolTipId: string;
}) => {
  const [showAvailable] = useAtom(showAvailableState);
  const [, setInfoTooltipOpen] = useAtom(infoTooltipOpenAtom);

  const isMobile = () => {
    return window.matchMedia('(max-width: 640px)').matches;
  };

  const setDataToolTip = toolTipId
    ? {
        'data-tooltip-id': toolTipId,
        'data-tooltip-title': title,
        'data-tooltip-info': text,
        'data-tooltip-content': 'dsadsad',
        'data-tooltip-place': toolTipPlace,
      }
    : {};

  const classNames = ['view-path', showAvailable ? 'show' : ''];

  return (
    <path
      id={id.toString()}
      className={classNames.join(' ')}
      d={d}
      onClick={() => {
        if (isMobile()) setInfoTooltipOpen(prev => !prev);
      }}
      {...setDataToolTip}
    />
  );
};

export default AreaViewInfo;
